import { render } from "./PageSizeSelector.vue?vue&type=template&id=11403e8f&scoped=true"
import script from "./PageSizeSelector.vue?vue&type=script&lang=js"
export * from "./PageSizeSelector.vue?vue&type=script&lang=js"

import "./PageSizeSelector.vue?vue&type=style&index=0&id=11403e8f&lang=scss&scoped=true"

import exportComponent from "/Users/perthpiti/InsightEra/ENOLA/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11403e8f"]])

export default __exports__